export const ongoingIDOColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    align: 'right'
  },
  {
    id: 'ecosystems',
    label: 'EcoSystem',
    align: 'right'
  },
  {
    id: 'categories',
    label: 'Category',
    align: 'right'
  },
  {
    id: 'investors',
    label: 'Investors',
    cellRenderer: 'textRenderer',
    align: 'right'
  },
  {
    id: 'launch_mkt_cap',
    label: 'Initial Market Capital',
    align: 'right'
  },

  {
    id: 'launch_date',
    label: 'Start Date',
    align: 'right'
  },
  {
    id: 'launch_end_date',
    label: 'End Date',
    align: 'right'
  },
  {
    id: 'ido_price',
    label: 'Initial Price',
    align: 'right'
  }
];

export const pastIDOColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    align: 'right',
    size: 'small'
  },
  {
    id: 'ecosystems',
    label: 'EcoSystem',
    align: 'right'
  },
  {
    id: 'categories',
    label: 'Category',
    align: 'right',
    size: 'medium'
  },
  {
    id: 'investors',
    label: 'Investors',
    cellRenderer: 'textRenderer',
    align: 'right',
    size: 'small'
  },
  {
    id: 'launch_mkt_cap',
    label: 'Initial Market Capital',
    align: 'right'
  },

  {
    id: 'launch_date',
    label: 'Start Date',
    align: 'right'
  },
  {
    id: 'launch_end_date',
    label: 'End Date',
    align: 'right'
  },
  {
    id: 'ido_price',
    label: 'Initial Price',
    align: 'right'
  }
];

export const upcommingIDOColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    align: 'right'
  },
  {
    id: 'ecosystems',
    label: 'EcoSystem',
    align: 'right'
  },
  {
    id: 'categories',
    label: 'Category',
    align: 'right'
  },
  {
    id: 'investors',
    label: 'Investors',
    cellRenderer: 'textRenderer',
    align: 'right'
  },

  {
    id: 'launch_mkt_cap',
    label: 'Initial Market Capital',
    align: 'right'
  },

  {
    id: 'launch_date',
    label: 'Start Date',
    align: 'right'
  },
  {
    id: 'launch_end_date',
    label: 'End Date',
    align: 'right'
  },
  {
    id: 'ido_price',
    label: 'Initial Price',
    align: 'right'
  }
];

export const tokenVestingColumns = [
  {
    id: 'type',
    label: '',
    align: 'right'
  },
  {
    label: 'Supply %',
    align: 'right'
  },
  {
    id: 'alloc_supply',
    label: 'Tokens',
    align: 'right'
  },
  {
    label: 'Vesting',
    align: 'right'
  }
];
